import React from 'react';
import { IResortShortReport } from '@/api/region/types';
import { ResortNameLink } from '@/components/common/ResortNameLink';
import { Routes } from '@/routes';

// Permanently closed resorts carry no useful stats — just list the
// names so the section's still findable. text-sm sits on the row rather
// than the link so the name and its optional region suffix share a size —
// the suffix is a sibling of the link, not a child.
export const PermClosedList = ({
  rows, showRegion = false,
}: { rows: IResortShortReport[]; showRegion?: boolean }) => (
  <ul className="overflow-hidden rounded-md border border-border bg-card">
    {rows.map((r) => (
      <li
        key={r.uuid}
        className="border-b border-border px-4 py-3 text-sm last:border-b-0"
      >
        <ResortNameLink
          resort={r}
          href={Routes.resortSnowReport(r)}
          showRegion={showRegion}
          className="font-medium text-foreground"
        />
      </li>
    ))}
  </ul>
);
